module.exports = __webpack_public_path__ + "static/media/vk_color_big.28ab2e97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/vk_color_big.png
// module id = ./src/assets/media/vk_color_big.png
// module chunks = 16